import { render, staticRenderFns } from "./ClaimNotFound.vue?vue&type=template&id=d69f6080"
import script from "./ClaimNotFound.vue?vue&type=script&lang=js"
export * from "./ClaimNotFound.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports